module.exports = __webpack_public_path__ + "img/first_bg.27e748c7.png";